import {
  chakra,
  forwardRef,
  type TableBodyProps as ChakraTbodyProps,
} from '@chakra-ui/react-v2';
import { cx } from '@chakra-ui/utils';

import { useTableStyles } from '../TableStylesContext';
import { getClassName } from './className';

export type TbodyProps = ChakraTbodyProps;

export const Tbody = forwardRef<TbodyProps, 'tbody'>(
  ({ className, ...props }, ref) => {
    const { tbody: tbodyStyles } = useTableStyles() ?? {};

    return (
      <chakra.tbody
        className={cx(getClassName('tbody'), className)}
        {...props}
        ref={ref}
        __css={tbodyStyles}
      />
    );
  },
);
